import React from 'react';

export const ClickBttn = ({
  bttnClass = '', // avoids 'TypeError: e.target.className.indexOf is not a function' when Verge3d is in use
  iconId = undefined,
  iconClass,
  iconType,
  onBttnClick,
}: {
  bttnClass?: string | undefined;
  iconId?: string;
  iconClass: string;
  iconType: JSX.Element;
  onBttnClick: (targetId: string) => void;
}) => (
  <div className={bttnClass}>
    <div
      id={iconId}
      className={iconClass}
      onClick={(event: React.MouseEvent<HTMLDivElement>) =>
        onBttnClick(event.currentTarget.id)
      }
    >
      {iconType}
    </div>
  </div>
);
